function makeEnum(mapping) {
  const reverseMapping = Object.keys(mapping).reduce((acc, key) => ({...acc, [mapping[key]]: key}), {});
  return {
    asString(code) {
      if (typeof code === 'number') {
        return reverseMapping[code];
      } else {
        return reverseMapping[mapping[code]];
      }
    },
    asNumber(code) {
      if (typeof code === 'number') {
        return mapping[reverseMapping[code]];
      } else {
        return mapping[code];
      }
    },
    ...mapping,
    ...reverseMapping};
}

module.exports = makeEnum;
